exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".normal-button{color:#fff;background:#007dbc}.action-group{margin-top:5px}.action-group-text{font-weight:bold;margin-right:10px;opacity:.5}.action-group-error{text-align:right;font-style:italic;font-size:12px;color:#a94442}", ""]);

// exports
